export default __webpack_public_path__ + "static/media/spotlight-series-mr-ramveer-tanwar.388cdcf7.jpg";